/* global $ */
import React, { useEffect, useRef, useState } from "react";
import "./treeView.css";
import $ from "jquery";
import "jstree";
import { useTreeView } from "../../context/treeViewContext";
import { db } from "../../config/firebaseConfig";
import { collection, getDocs,where, query } from "firebase/firestore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faDroplet, faNetworkWired, faBolt, faWind, faPlus } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";






const TreeView = ({ masterID }) => {
    const treeRef = useRef(null);
    const { setSelectedNodeID } = useTreeView();
    const [treeData, setTreeData] = useState([]);
    const navigate = useNavigate();
    const currentProjectID = localStorage.getItem("currentProjectID");

    // データ取得＆変換処理（初回のみ）
    useEffect(() => {
        fetchDataAndBuildTree();
    }, []);

    // Firestore からデータを取得し、jstree 向けに変換
    const fetchDataAndBuildTree = async () => {
        try {
            const q = query(
                collection(db, "00_DeviceMasterTable"),
                where("projectID", "==", currentProjectID)
            );
            const snapshot = await getDocs(q);
            // const snapshot = await getDocs(
            //     collection(db, "00_DeviceMasterTable"),
            //     where("projectID", "==", currentProjectID)
            // );
            const rawData = snapshot.docs.map(doc => doc.data());

            const editingNodeId = "master_" + masterID; // 編集対象ノード（＝自分自身）
            const transformedData = transformToTreeData(rawData, editingNodeId);

            setTreeData(transformedData);
        } catch (error) {
            console.error("🔥 Firestoreデータの取得に失敗:", error);
        }
    };

    // jstree 向けのデータに整形する
    const transformToTreeData = (data, editingNodeId) => {
        const activeNodes = data.filter(item => item.deleted !== true);

        // ノードをマッピング形式で保持（key = master_ID 付きID）
        const nodeMap = {};
        activeNodes.forEach(item => {
            const nodeId = "master_" + item.masterID;
            const parentId = item.parentID ? "master_" + item.parentID : "#";
            const nodeName = item.name || "名称未設定";
            const parentID = item.parentID || "";
            const sortIndex = item.sortIndex ?? 9999;
            const nodeType = item.isCategory || "unclassified";

            nodeMap[nodeId] = {
            id: nodeId,
            parent: parentId,
            text: nodeName,
            // text: `${nodeName}, ${item.parentID || ""}, ${sortIndex}`,
            type: nodeType,
            sortIndex: item.sortIndex ?? 9999, // 未定義なら末尾扱い
            };
        });

        // 並び替えのために親ごとにグループ化してsortIndexでソート
        const groupedByParent = {};
        Object.values(nodeMap).forEach(node => {
            const parent = node.parent;
            if (!groupedByParent[parent]) groupedByParent[parent] = [];
            groupedByParent[parent].push(node);
        });

        // 再帰的に並べていく
        const buildSortedTree = (parentId = "#") => {
            const children = groupedByParent[parentId] || [];
            children.sort((a, b) => a.sortIndex - b.sortIndex);

            const result = [];
            for (const child of children) {
            result.push(child);
            result.push(...buildSortedTree(child.id));
            }
            return result;
        };

        // 自身と子孫ノードを無効化（選択不可にする）
        if (editingNodeId && nodeMap[editingNodeId]) {
            const blockedNodes = getDescendants(editingNodeId, nodeMap);
            blockedNodes.push(editingNodeId); // 自分自身も追加

            blockedNodes.forEach(id => {
            if (nodeMap[id]) {
                nodeMap[id].state = { disabled: true };
            }
            });
        }

        return buildSortedTree(); // ソートされたツリーデータを返す
    };

    // 再帰的に子ノード（子孫）を取得する
    const getDescendants = (targetId, nodeMap) => {
        const result = [];

        const findChildren = (id) => {
            for (const node of Object.values(nodeMap)) {
                if (node.parent === id) {
                    result.push(node.id);
                    findChildren(node.id); // 再帰的に探索
                }
            }
        };

        findChildren(targetId);
        return result;
    };

    // jstree の初期化とクリーンアップ
    useEffect(() => {
    if (treeData.length === 0) return;

    $(treeRef.current).jstree({
        core: {
            data: treeData,
            themes: { icons: true }
        },
        types: {
            "category": { icon: "fa-solid fa-folder" },
            "device": { icon: "fa-solid fa-microchip" },
            "unclassified": { icon: "fa-solid fa-circle" }
        },
        plugins: ["types", "wholerow", "sort", "state"],
        sort: (a, b) => {
            const nodeA = treeData.find(n => n.id === a);
            const nodeB = treeData.find(n => n.id === b);
            return nodeA?.sortIndex - nodeB?.sortIndex;
        }
    })
    .on("select_node.jstree", (e, data) => {
        setSelectedNodeID(data.node, data.instance._model.data);
    })
.on("hover_node.jstree", (e, data) => {
    const nodeId = data.node.id;
    const $node = $(`#${nodeId}`); // ← .jstree-node 全体を取得
    const $anchor = $(`#${nodeId}_anchor`);

    if (!$node.find(".edit-icon").length) {
        // relative にする（親が relative 必須）
        $node.css("position", "relative");

        const iconHTML = `
            <span class="edit-icon" title="編集">
                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="pencil"
                    class="svg-inline--fa fa-pencil" role="img" xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512" width="14" height="14">
                    <path fill="currentColor"
                        d="M362.7 19.3l130 130c12.5 12.5 12.5 32.8 0 45.3L204.3 483.3c-4.5 4.5-10.2 7.6-16.4 9.1l-112 28c-11.1 2.8-21.3-7.4-18.5-18.5l28-112c1.5-6.2 4.6-11.9 9.1-16.4L347.3 19.3c12.5-12.5 32.8-12.5 45.4 0z">
                    </path>
                </svg>
            </span>
        `;

        const $icon = $(iconHTML);

        $icon.on("click", (e) => {
            e.stopPropagation();
            // alert(`編集: ${data.node.text} (ID: ${data.node.id.split("_")[1]})`);
            navigate(`/EditMaster/${data.node.id.split("_")[1]}`)
        });

        $node.append($icon); // ← jstree-node 直下に追加
    }
})
.on("dehover_node.jstree", (e, data) => {
    const nodeId = data.node.id;
    $(`#${nodeId}`).find(".edit-icon").remove();
});




    return () => {
        $(treeRef.current).jstree("destroy");
    };
}, [treeData]);




    const localRef = useRef(null);
    useEffect(() => {
        if (localRef.current) {
            $(localRef.current).jstree({
            core: {
                data: [
                // あなたのツリーデータをここに入れる
                ],
                check_callback: true,
            },
                plugins: ["dnd", "wholerow"],
            });

            if (treeRef) {
                treeRef.current = localRef.current;
            }
        }
    }, []);

    return <div ref={treeRef} id="jstree"></div>;
};

export default TreeView;
